export enum FolderViewType {
    LAYERS = "LAYERS",
    TYPES = "TYPES",
    STEREOTYPES = "STEREOTYPES",
}